import moment from 'moment/src/moment'
import { DATE_FORMAT } from '@/main.config'

export const fullName = {
  methods: {
    getFullName(obj) {
      if (this.isNeuroAdmin) {
        if (
          !obj.user_roles ||
          (obj.user_roles &&
            (!obj.user_roles.includes('hospital_admin') && !obj.user_roles.includes('neuro_admin')))
        ) {
          return String(obj.id).padStart(5, '0')
        }
      }
      let fullName = `${obj.surname} ${obj.name}`
      if (obj.middle_name) {
        fullName += ' ' + obj.middle_name
      }
      return fullName
    },
    getFullNameWithBirth(obj) {
      let fullName = this.getFullName(obj)

      if (obj.birth_date) {
        let birth = moment(obj.birth_date).format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
        fullName += ' - ' + birth
      }

      return fullName
    },
    getSurnameWithInitials(obj) {
      if (this.isNeuroAdmin) {
        return String(obj.id).padStart(5, '0')
      }
      let fullName = obj.surname
      if (obj.name) {
        fullName += ` ${obj.name[0]}.`
      }
      if (obj.middle_name) {
        fullName += `${obj.middle_name[0]}.`
      }
      return fullName || '?'
    }
  }
}
